// 1:两个都不显示  2:智优投  3:智推宝 4：两个都显示
export const HIDE_ZHI_GUANG_TONG_AND_ZHI_TUI_BAO = 1
export const SHOW_ZHI_GUANG_TONG = 2
export const SHOW_ZHI_TUI_BAO = 3
export const BOTH_SHOW__ZHI_GUANG_TONG_AND_ZHI_TUI_BAO = 4
